import { render } from "./App.vue?vue&type=template&id=f9348ba8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f9348ba8&lang=css"

import exportComponent from "/home/max/Code/Phida/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__